// extracted by mini-css-extract-plugin
export default {"container":"style_container__KImov","small":"style_small__eNrnO","icon":"style_icon__F2F53"};